import { NavLink } from "react-router-dom";
import { NAV_GROUPS, BOTTOM_NAV, LOGO_URL } from "@/lib/nav";
import { cn } from "@/lib/utils";

function NavItem({ item, onNavigate }) {
    const Icon = item.icon;
    return (
        <NavLink
            to={item.to}
            onClick={onNavigate}
            data-testid={`sidebar-nav-${item.testid}`}
            className={({ isActive }) =>
                cn(
                    "group flex items-center gap-3 px-3 py-2 rounded-sm text-sm transition-colors duration-200 relative",
                    isActive
                        ? "bg-volt/10 text-white"
                        : "text-muted-foreground hover:text-white hover:bg-white/5"
                )
            }
        >
            {({ isActive }) => (
                <>
                    {isActive && <span className="absolute left-0 top-1.5 bottom-1.5 w-0.5 bg-volt rounded-full" />}
                    <Icon className={cn("w-[18px] h-[18px] shrink-0", isActive && "text-volt")} />
                    <span className="truncate">{item.label}</span>
                </>
            )}
        </NavLink>
    );
}

export function SidebarContent({ onNavigate }) {
    return (
        <div className="flex flex-col h-full">
            <div className="flex items-center gap-2.5 px-5 h-16 border-b border-border shrink-0">
                <div
                    className="w-9 h-9 rounded-sm bg-black shrink-0 border border-white/10"
                    style={{ backgroundImage: `url(${LOGO_URL})`, backgroundSize: "175%", backgroundPosition: "center 32%", backgroundRepeat: "no-repeat" }}
                />
                <div className="leading-none">
                    <div className="font-heading font-extrabold text-[15px] tracking-tight text-white">WhiteWater<span className="text-volt">AI</span></div>
                    <div className="text-[9px] uppercase tracking-[0.25em] text-muted-foreground mt-0.5">Gameplay Coach</div>
                </div>
            </div>

            <nav className="flex-1 overflow-y-auto px-3 py-5 space-y-6">
                {NAV_GROUPS.map((group) => (
                    <div key={group.label}>
                        <div className="px-3 mb-2 text-[10px] uppercase tracking-[0.22em] text-muted-foreground/70 font-semibold">
                            {group.label}
                        </div>
                        <div className="space-y-0.5">
                            {group.items.map((item) => (
                                <NavItem key={item.to} item={item} onNavigate={onNavigate} />
                            ))}
                        </div>
                    </div>
                ))}
            </nav>

            <div className="px-3 py-4 border-t border-border space-y-0.5 shrink-0">
                {BOTTOM_NAV.map((item) => (
                    <NavItem key={item.to} item={item} onNavigate={onNavigate} />
                ))}
            </div>
        </div>
    );
}

export function Sidebar() {
    return (
        <aside className="hidden lg:flex w-64 shrink-0 border-r border-border bg-[#0c0c0c] h-screen sticky top-0">
            <SidebarContent />
        </aside>
    );
}
